import { FC } from "react";
import { useTheme } from "@mui/material/styles";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { useSection } from "lib/context/section";

type Props = {
  loading?: boolean;
  disabled: boolean;
  handleBack: () => void;
  stepsNumber: number;
  isTokenExpired: boolean;
};

const Stepper: FC<Props> = ({ disabled, handleBack, loading, stepsNumber, isTokenExpired }) => {
  const theme = useTheme();
  const isDisabled = isTokenExpired || !disabled;
  const { sectionId, setSectionId } = useSection();

  return (
    <MobileStepper
      //variant='progress'
      variant='text'
      position='static'
      steps={stepsNumber}
      activeStep={sectionId - 1}
      sx={{ maxWidth: "100%", flexGrow: 1 }}
      nextButton={
        <LoadingButton
          size='small'
          type='submit'
          loading={loading}
          loadingPosition='start'
          startIcon={<SaveIcon />}
          disabled={sectionId > stepsNumber || isDisabled}
        >
          <span>Siguiente</span>
          {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </LoadingButton>
      }
      backButton={
        <Button size='small' onClick={handleBack} disabled={sectionId === 1}>
          {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          Anterior
        </Button>
      }
    />
  );
};

export default Stepper;
